import { LeaderboardState } from './types';

export const getScopeParams = (state: LeaderboardState) => {
	if (state.scopeType === 'team' && state.selectedTeam) {
		return { team: state.selectedTeam };
	}
	if (state.scopeType === 'department' && state.selectedDepartment) {
		return { department: state.selectedDepartment };
	}
	return {};
};

export const getLeaderboardFilterKey = (state: LeaderboardState) =>
	JSON.stringify({
		selectedTimeframe: state.selectedTimeframe,
		customStartDate: state.customStartDate ?? '',
		customEndDate: state.customEndDate ?? '',
		scopeType: state.scopeType,
		selectedTeam: state.selectedTeam ?? '',
		selectedDepartment: state.selectedDepartment ?? '',
	});
